<template>
  <div style="width: 100%; height: 100%">
    <div v-if="!LoadPage" class="login">
      <!-- 品牌渐变底 + 可选的租户背景图（低透明度，保证渐变始终主导） -->
      <div class="lg-page">
        <div
          v-if="setting.homeBackImg"
          class="lg-page__texture"
          :style="`background-image: url('${setting.homeBackImg}')`"
        ></div>

        <!-- 品牌角标装饰（呼应标志的方括号） -->
        <span class="lg-bracket lg-bracket--tl" aria-hidden="true"></span>
        <span class="lg-bracket lg-bracket--br" aria-hidden="true"></span>

        <div class="lg-shell">
          <!-- 标志：优先用后台配置，否则用内置新标志 -->
          <img
            class="lg-logo"
            :src="setting.logo || defaultLogo"
            alt="VTM Vending"
            @click="handlerChangePage"
          />

          <div class="lg-card">
            <el-form
              :label-position="labelPosition"
              class="lg-form"
              :rules="rules"
              ref="login"
              label-width="80px"
              :model="login"
            >
              <!-- 登录 -->
              <template v-if="type === 0">
                <h1 class="lg-card__title">{{ $t("login.login") }}</h1>

                <el-form-item prop="account">
                  <el-input
                    v-model="login.account"
                    :placeholder="$t('login.userName')"
                    @keyup.enter.native="enterSubmit('login')"
                    @input="login.account = login.account.toLowerCase()"
                    prefix-icon="el-icon-message"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="password">
                  <el-input
                    v-model="login.password"
                    type="password"
                    @keyup.enter.native="enterSubmit('login')"
                    :placeholder="$t('login.password')"
                    auto-complete="off"
                    prefix-icon="el-icon-lock"
                    show-password
                  ></el-input>
                </el-form-item>

                <el-form-item prop="code" v-if="failNum > 2">
                  <div class="lg-captcha">
                    <el-input
                      v-model="login.code"
                      prefix-icon="iconfont icon-anquan"
                      :placeholder="$t('login.code')"
                    ></el-input>
                    <div class="lg-captcha__img" @click="getLoginCode()">
                      <img :src="codeImage" alt="captcha" />
                    </div>
                  </div>
                </el-form-item>

                <div class="lg-row">
                  <el-checkbox v-model="login.checked">
                    <el-tooltip class="item" effect="dark" :content="$t('login.checked')" placement="right">
                      <span>{{ $t("login.remember") }}</span>
                    </el-tooltip>
                  </el-checkbox>
                  <span class="lg-link" @click="forget(1)">{{ $t("login.forgotPassword") }}</span>
                </div>

                <el-button class="lg-submit" type="primary" @click="submitForm('login')" :loading="loading">
                  {{ loading ? $t("login.logging") : $t("login.login") }}
                </el-button>
              </template>

              <!-- 忘记密码 -->
              <template v-else>
                <h1 class="lg-card__title">{{ $t("login.updatePassword") }}</h1>

                <el-form-item prop="emailManger" :error="emailManger">
                  <el-input
                    v-model="login.emailManger"
                    :placeholder="$t('login.emailManger')"
                    prefix-icon="el-icon-message"
                    auto-complete="off"
                  ></el-input>
                </el-form-item>

                <el-form-item prop="captcha">
                  <div class="lg-captcha">
                    <el-input
                      v-model="login.captcha"
                      :placeholder="$t('login.verify')"
                      prefix-icon="iconfont icon-anquan"
                      auto-complete="off"
                    ></el-input>
                    <el-button class="lg-captcha__btn" @click="captcha">{{ $t("login.captchaText") }}</el-button>
                  </div>
                </el-form-item>

                <el-form-item prop="newPassword">
                  <el-input
                    v-model="login.newPassword"
                    :placeholder="$t('login.newPassword')"
                    prefix-icon="el-icon-lock"
                    show-password
                    auto-complete="off"
                  ></el-input>
                </el-form-item>

                <div class="lg-row lg-row--end">
                  <span class="lg-link" @click="forget(0)">{{ $t("login.backLogin") }}</span>
                </div>

                <el-button class="lg-submit" type="primary" @click="submitForgot('login')" :loading="loading">
                  {{ loading ? $t("login.modifying") : $t("login.updatePassword") }}
                </el-button>
              </template>
            </el-form>

            <!-- 移动端应用下载 -->
            <div class="lg-apps">
              <div class="lg-apps__sep"><span>{{ $t("login.getApp") }}</span></div>
              <div class="lg-apps__row">
                <el-tooltip effect="dark" placement="bottom">
                  <div class="lg-app" @click="handlerDownLoad(1)">
                    <img src="../assets/img/ios.png" alt="" />
                    <span>
                      <strong>{{ $t("login.iosApp") }}</strong>
                      <em>{{ $t("login.downLoad") }}</em>
                    </span>
                  </div>
                  <template #content>
                    <img src="../assets/img/appstore_url.png" alt="" class="lg-qr" />
                  </template>
                </el-tooltip>

                <el-tooltip effect="dark" placement="bottom">
                  <div class="lg-app" @click="handlerDownLoad(2)">
                    <img src="../assets/img/android.png" alt="" />
                    <span>
                      <strong>{{ $t("login.androidApp") }}</strong>
                      <em>{{ $t("login.downLoad") }}</em>
                    </span>
                  </div>
                  <template #content>
                    <img src="../assets/img/android_url.png" alt="" class="lg-qr" />
                  </template>
                </el-tooltip>
              </div>
            </div>
          </div>

          <!-- 页脚链接：优先用后台配置（v-html），未配置时用内置的 VTM 链接 -->
          <div class="lg-foot">
            <img class="lg-foot__logo" :src="setting.homeDownImg || footLogo" alt="VTM" />
            <div v-if="setting.homeDownText" class="lg-foot__links" v-html="setting.homeDownText"></div>
            <div v-else class="lg-foot__links">
              <p v-for="link in footLinks" :key="link.url">
                <a :href="link.url" target="_blank" rel="nofollow noopener noreferrer">{{ link.label }}</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="lg-loading">
      <div v-loading="true"></div>
    </div>
  </div>
</template>

<script>
  import language from "../utils/language";
  import config from "@/http/config";
  const md5 = require("js-md5");
  export default {
    name: "Login",
    data() {
      const account = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.userName")));
        } else {
          if (value === "admin") {
            callback();
          } else {
            // 验证是否含有大写字母
            let regUper = new RegExp("[A-Z]+");
            // 验证格式
            let reg = new RegExp("^[a-z0-9A-Z]+[- |a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
            if (regUper.test(value)) {
              callback(new Error(this.$t("login.pChangeLower")));
            } else if (!reg.test(value)) {
              callback(new Error(this.$t("login.emailError")));
            }
          }
          callback();
        }
      };
      const password = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.password")));
        } else {
          callback();
        }
      };
      const code = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.verify")));
        } else {
          callback();
        }
      };
      const emailManger = (rule, value, callback) => {
        if (value === "") {
          this.verify = false;
          callback(new Error(this.$t("login.userName")));
        } else {
          let reg = new RegExp("^[a-z0-9A-Z]+[- |a-z0-9A-Z._]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$");
          if (!reg.test(value)) {
            this.verify = false;
            callback(new Error(this.$t("login.emailError")));
          } else {
            this.verify = true;
            callback();
          }
        }
      };
      const captcha = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.verify")));
        } else {
          callback();
        }
      };
      const newPassword = (rule, value, callback) => {
        if (value === "") {
          callback(new Error(this.$t("login.password")));
        } else {
          callback();
        }
      };
      return {
        appInfo: {
          androidDownUrl: "",
          androidQrCode: "",
          androidVersion: "",
          h5DownUrl: "",
          h5QrCode: "",
          h5Version: "",
          iosDownUrl: "",
          iosQrCode: "",
          iosVersion: ""
        },
        LoadPage: true,
        uploadUrl: config.baseUrl + this.$url.IDard.jzupload,
        headers: {
          appId: "123456789"
        },
        zmURL: "",
        fmURL: "",
        localtype: "",
        equipmentNo: "",
        age: 0,
        ischengnian: 3,
        labelPosition: "top",
        loading: false,
        login: {
          account: "",
          password: "",
          code: "",
          checked: false,
          codeKey: "",
          emailManger: "",
          captcha: "",
          newPassword: ""
        },
        codeImage: "",
        verify: false,
        passVal: "",
        failNum: 0,
        type: 0,
        rules: {
          account: [{ required: true, validator: account, trigger: "blur" }],
          password: [{ required: true, validator: password, trigger: "blur" }],
          code: [{ required: true, validator: code, trigger: "blur" }],
          emailManger: [{ required: true, validator: emailManger, trigger: "blur" }],
          captcha: [{ required: true, validator: captcha, trigger: "blur" }],
          newPassword: [{ required: true, validator: newPassword, trigger: "blur" }]
        },
        language: "",
        emailManger: "",
        port: "",
        setting: {},
        loginCountry: "",
        txMapKey: "",
        // 后台未配置标志时回退到内置的新品牌标志（深底用白色版）
        defaultLogo: require("../assets/img/logo-white.png"),
        // 后台未配置页脚时的默认链接（与线上 vapetm 登录页一致）
        footLogo: require("../assets/img/logo-vtm-footer-white.png"),
        footLinks: [
          { label: "VTM Vending Online Store", url: "https://vapetm.com/collections/" },
          { label: "ReyVend", url: "https://reyvend.com/" },
          { label: "Privacy Policy", url: "https://vapetm.com/pages/privacy-policy-and-sms" },
          { label: "End User License Agreement (EULA)", url: "https://vapetm.com/pages/vapetm-software-eula" }
        ]
      };
    },
    mounted() {
      let _self = this;
      let uId = "";
      if (this.$route.query.uId) {
        uId = this.$route.query.uId;
        this.$cookies.set("loginuserId", uId);
      } else {
        uId = 1;
        this.$cookies.set("loginuserId", uId);
      }
      let that = this;
      // init language
      this.lang();
      window.onkeydown = function (event) {
        if (event.key && event.key === "Enter") {
          that.submitForm("login");
        }
      };
      this.port = window.location.host.split(":")[1];
      // 获取记住的密码
      let Account = localStorage.getItem("Account");
      if (Account) {
        Account = JSON.parse(Account);
        that.login.checked = true;
        that.login.account = Account.account;
        that.login.password = this.$tools.Decrypt(Account.password);
      }
      let hostname = window.location.hostname;
      let firstDotIndex = hostname.indexOf(".");
      let prefix = hostname.substring(0, firstDotIndex);

      //  获取配置信息
      let url = this.$url.Promote.getDefault;
      let method = this.$method.get;
      this.$api
        .request(url, method, {
          key: "LOGO",
          uId,
          loginLocale: prefix || "custom"
          // loginLocale: "custom",
        })
        .then(res => {
          if (res.code === 0) {
            this.setting = res.data.logo;
            this.appInfo = res.data.app || {};
            let icon = res.data.logo.icon;

            this.setFavicon(icon);
            let djs = setTimeout(function () {
              clearTimeout(djs);
              _self.LoadPage = false;
            }, 1000);
          }
        })
        .catch(err => {
          console.log(err);
          this.$notify({
            title: this.$t("common.tip"),
            message: err.msg,
            type: "error"
          });
        });
    },
    methods: {
      // 动态设置网站icon
      setFavicon(iconUrl) {
        let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = iconUrl;
        document.getElementsByTagName("head")[0].appendChild(link);
      },
      handlerCopy() {
        this.$tools.copy(this.appInfo.h5DownUrl || "");
      },
      handlerDownLoad(n) {
        switch (+n) {
          case 1:
            // 点击ios按钮
            window.open("https://apps.apple.com/us/app/vtm-vending/id6738745536", "_blank");
            break;
          case 2:
            // 在线下载
            window.open("https://foreign-custom.s3.us-east-2.amazonaws.com/noDelete/apk/vending.apk", "_blank");
            break;
          case 3:
            // 点击h5按钮
            // if (this.appInfo.h5DownUrl) window.open(this.appInfo.h5DownUrl, "_blank");
            break;
          case 4:
            // 点击google按钮
            // window.open("", "_blank");
            break;
        }
      },
      lang() {
        let lang = this.$cookies.get("lang");
        if (lang) {
          this.language = language[lang]["1"];
          this.$i18n.locale = lang;
          this.$cookies.set("lang", lang, { expires: 1095 });
        } else {
          this.language = language["en_US"]["1"];
          this.$i18n.locale = "en_US";
        }
      },
      commandLanguage(command) {
        this.language = language[command]["1"];
        this.$i18n.locale = command;
        this.$cookies.set("lang", command, { expires: 1095 });
      },
      submitForm(formName) {
        const that = this;
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.loading = true;
            const obj = {
              userName: that.login.account,
              passWord: md5(that.login.password),
              lang: this.$cookies.get("lang")
            };
            obj.code = that.login.code;
            obj.codeKey = that.login.codeKey;
            obj.checked = that.login.checked;
            that.$api
              .request(that.$url.Login.login, that.$method.post, that.$qs.stringify(obj))
              .then(res => {
                if (res.code === 0) {
                  if (res.data !== "") {
                    let userInfo = res.data;
                    localStorage.setItem("pId", userInfo.pid);
                    localStorage.setItem("uId", userInfo.uid);
                    localStorage.setItem("userName", userInfo.userName);
                    localStorage.setItem("warehouseAccount", that.login.account);
                    sessionStorage.setItem("localuserid", userInfo.uid);
                    if (that.login.checked) {
                      localStorage.setItem(
                        "Account",
                        JSON.stringify({
                          account: that.login.account,
                          password: that.$tools.Encrypt(that.login.password)
                        })
                      );
                    } else {
                      localStorage.removeItem("Account");
                    }
                    sessionStorage.setItem("parentId", userInfo.pid);
                    that.$cookies.set("parentId", userInfo.pid);
                    userInfo.checked = that.login.checked;
                    userInfo.token = res.data.token;
                    that.$store.dispatch("login", userInfo).then(() => {
                      that.$router.push("/main?showAgreePrivacy=" + userInfo.agreement);
                    });
                  }
                } else {
                  that.failNum++;
                  if (that.failNum > 2) {
                    that.getLoginCode();
                  }
                }
                that.loading = false;
              })
              .catch(() => {
                that.loading = false;
              });
          } else {
            return false;
          }
        });
      },
      // 找回密码
      submitForgot(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            this.loading = !this.loading;
            let obj = {
              userName: this.login.emailManger,
              passWord: md5(this.login.newPassword),
              emailCode: this.login.captcha
            };
            this.$api
              .request(this.$url.User.findPassword, this.$method.post, obj)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.error(res.msg);
                }
                this.loading = false;
              })
              .catch(() => {
                this.$message.error(this.$t("login.updatePasswordError"));
                this.loading = false;
              });
          }
        });
      },
      enterSubmit(formName) {
        this.submitForm(formName);
      },
      //   icon点击跳转
      handlerChangePage() {
        if (!this.setting.logoUrl) return;
        location.href = this.setting.logoUrl;
      },
      // 登录验证码
      getLoginCode() {
        this.$api.request(this.$url.Login.captcha, this.$method.get).then(res => {
          if (res.code === 0) {
            this.codeImage = res.data.code;
            this.login.codeKey = res.data.key;
          }
        });
      },
      // 切换登录或忘了密码
      forget(val) {
        this.type = val;
        this.$refs.login.clearValidate();
      },
      // 隐私协议
      handleCommand(command) {
        this.$message("click on item " + command);
        window.open("http://securitypolicy.reyeah.com?type=" + command);
      },
      // 忘记密码手机验证码
      captcha() {
        if (this.verify) {
          if (this.login.emailManger === "") {
            this.emailManger = this.$t("login.emailManger");
          } else {
            this.$api
              .request(this.$url.User.verifyUser, this.$method.post, {
                userName: this.login.emailManger
              })
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(res.msg);
                } else {
                  this.$message.warning(res.msg);
                }
              });
          }
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
  /* ===== 登录页：2026 品牌视觉（深海军蓝 → 青 渐变） ===== */
  .login {
    height: 100%;
  }

  .lg-page {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    padding: 32px 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: auto;
    background: var(--vtm-brand-gradient);
  }

  /* 租户自定义背景图：压到很低的透明度，只做肌理，渐变仍是主角 */
  .lg-page__texture {
    position: absolute;
    inset: 0;
    background-size: cover;
    background-position: center;
    opacity: 0.14;
    mix-blend-mode: soft-light;
    pointer-events: none;
  }

  /* 品牌方括号装饰，呼应标志 */
  .lg-bracket {
    position: absolute;
    width: 74px;
    height: 74px;
    opacity: 0.55;
    pointer-events: none;
  }

  // 注意：border 简写若省略颜色会退回 currentColor，这里显式写出品牌绿
  .lg-bracket--tl {
    top: 38px;
    left: 44px;
    border-top: 5px solid var(--vtm-mint);
    border-left: 5px solid var(--vtm-mint);
  }

  .lg-bracket--br {
    right: 44px;
    bottom: 38px;
    border-right: 5px solid var(--vtm-mint);
    border-bottom: 5px solid var(--vtm-mint);
  }

  /* 外壳比卡片宽，让页脚链接能排成一行；卡片自身再收窄居中 */
  .lg-shell {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 760px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .lg-logo {
    height: 46px;
    max-width: 260px;
    object-fit: contain;
    margin-bottom: 26px;
    cursor: pointer;
  }

  .lg-card {
    width: 100%;
    max-width: 424px;
    box-sizing: border-box;
    padding: 30px 30px 24px;
    border-radius: 14px;
    background: var(--vtm-surface);
    box-shadow: 0 20px 46px rgba(0, 0, 0, 0.36);
  }

  .lg-card__title {
    margin: 0 0 20px;
    font-family: var(--vtm-display);
    font-size: 22px;
    font-weight: 600;
    color: var(--vtm-heading);
  }

  .lg-form ::v-deep .el-form-item {
    margin-bottom: 16px;
  }

  .lg-form ::v-deep .el-input__inner {
    height: 44px;
    line-height: 44px;
    padding-left: 38px;
    font-size: 14px;
  }

  .lg-form ::v-deep .el-input__icon {
    line-height: 44px;
    font-size: 17px;
  }

  /* 验证码：输入框 + 图片/按钮并排 */
  .lg-captcha {
    display: flex;
    align-items: center;
    gap: 10px;

    ::v-deep .el-input {
      flex: 1;
    }
  }

  .lg-captcha__img {
    flex-shrink: 0;
    width: 122px;
    height: 44px;
    border: 1px solid var(--vtm-line-2);
    border-radius: 6px;
    overflow: hidden;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
  }

  .lg-captcha__btn {
    flex-shrink: 0;
    height: 44px;
  }

  .lg-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 2px 0 20px;
    font-size: 13px;
  }

  .lg-row--end {
    justify-content: flex-end;
  }

  .lg-link {
    color: var(--vtm-mint-ink);
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .lg-submit {
    width: 100%;
    height: 44px;
    font-size: 15px;
    font-weight: 600;
  }

  /* ---- 应用下载 ---- */
  .lg-apps {
    margin-top: 22px;
  }

  .lg-apps__sep {
    position: relative;
    text-align: center;
    margin-bottom: 14px;

    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      height: 1px;
      background: var(--vtm-line);
    }

    span {
      position: relative;
      padding: 0 10px;
      background: var(--vtm-surface);
      font-size: 12px;
      color: var(--vtm-ink-3);
    }
  }

  .lg-apps__row {
    display: flex;
    gap: 12px;
  }

  .lg-app {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    height: 50px;
    border-radius: 8px;
    background: var(--vtm-brand-deep);
    color: #fff;
    cursor: pointer;
    transition: background-color 0.18s ease, transform 0.18s ease;

    &:hover {
      background: #002a3a;
      transform: translateY(-1px);
    }

    img {
      width: 24px;
      height: 24px;
      display: block;
    }

    span {
      display: flex;
      flex-direction: column;
      line-height: 1.2;
    }

    strong {
      font-size: 13px;
      font-weight: 600;
    }

    em {
      font-style: normal;
      font-size: 11px;
      opacity: 0.72;
    }
  }

  .lg-qr {
    width: 148px;
    height: 148px;
    display: block;
  }

  /* ---- 页脚：左侧标志 + 右侧竖排链接（同线上经典登录页） ---- */
  .lg-foot {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 36px;
    margin-top: 30px;
  }

  .lg-foot__logo {
    width: 96px;
    height: 96px;
    flex-shrink: 0;
    object-fit: contain;
  }

  .lg-foot__links {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    text-align: left;

    ::v-deep p {
      margin: 0;
      font-family: var(--vtm-display);
      font-size: 17px;
      font-weight: 600;
      line-height: 1.35;
    }

    ::v-deep a {
      color: #fff;
      text-decoration: none;
      transition: opacity 0.16s ease;

      &:hover {
        opacity: 1;
        text-decoration: underline;
      }
    }

    ::v-deep span {
      color: #fff !important;
    }
  }

  .lg-loading {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* ---- 窄屏 ---- */
  @media (max-width: 560px) {
    .lg-bracket {
      display: none;
    }

    .lg-card {
      padding: 24px 20px 20px;
    }

    .lg-apps__row {
      flex-direction: column;
    }

    .lg-foot {
      gap: 18px;
    }

    .lg-foot__logo {
      width: 64px;
      height: 64px;
    }

    .lg-foot__links ::v-deep p {
      font-size: 14px;
    }
  }
</style>
